import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';

export default props => {
  console.log('props', props);
  return (
    <React.Fragment>
      <DialogTitle id="max-width-dialog-title">High Balance Agents</DialogTitle>
      <DialogContent>
        <DialogContentText>
          X where, <br />
          X = Number of top agents with current balance above high balance
          threshold <br />
          High balance threshold = {props.summary.high_balance_agent_threshold}
        </DialogContentText>
      </DialogContent>
    </React.Fragment>
  );
};
